/* Pholoh RE drop — header + home hero treatment.

   HEADER (every page): logo, hamburger, search and cart all go RE red.
   HOME HERO: heading text replaced by the hollow Resident Evil wordmark (red outline,
   transparent interior, full-bleed on mobile) -> small red "AVAILABLE NOW" -> a SHOP NOW
   button that is a red outline with red text and a see-through middle, linking to the
   collection.

   Kept as this one asset so the whole treatment reverts together: delete this file + its
   <script> include in layout/theme.liquid and the stock header/hero come back.

   Generated art (both made by processing the real files, not redrawn):
     assets/re-wordmark-outline.png — the logo's own alpha eroded 11px and subtracted,
       so the distressed edges are the original's.
     assets/pholoh-logo-red.png     — the header mark's alpha filled with RE red, so the
       shape is pixel-identical to the white one it replaces. */
(function () {
  var RED = '#C81E0F';
  var LIVE_TITLE = 'AVAILABLE NOW';
  var WORDMARK_FILE = 're-wordmark-outline.png';
  var LOGO_FILE = 'pholoh-logo-red.png';

  /* Build asset URLs from this script's own src, so nothing hardcodes a CDN path. */
  function assetUrl(file){
    var s = document.querySelector('script[src*="pholoh-re-countdown.js"]');
    if (!s) return null;
    var src = s.getAttribute('src') || '';
    return src.split('?')[0].replace(/pholoh-re-countdown\.js$/, '') + file;
  }

  function injectCss(){
    if (document.getElementById('re-hero-css')) return;
    var css = document.createElement('style');
    css.id = 're-hero-css';
    css.textContent =
      /* ---- header: hamburger / search / cart ---- */
      '.site-nav__link--icon{color:' + RED + '!important}' +
      '.site-nav__link--icon svg{fill:currentColor!important;color:' + RED + '!important}' +
      '.site-nav__link--icon svg path{fill:currentColor!important}' +
      /* the red logo file already carries the colour, so drop the white-out filter */
      '.site-header__logo img.re-logo-red,.site-header img.re-logo-red{filter:none!important}' +

      /* ---- hero wordmark: full-bleed on mobile ----
         The hero text sits inside .page-width; the negative calc margins break out of that
         container's padding rather than fighting it. */
      /* 92vw, centred: near edge-to-edge but with a little air either side so the letters
         don't collide with the phone bezel. */
      '.template-index .re-wordmark{display:block;width:92vw;max-width:none;height:auto;margin-left:calc(50% - 46vw);margin-right:calc(50% - 46vw)}' +
      '@media (min-width:769px){.template-index .re-wordmark{width:min(56vw,720px);margin-left:auto;margin-right:auto}}' +
      /* The theme wraps heading text in .animation-cropper (inline-flex + overflow:hidden)
         for its reveal animation. With a full-bleed image inside, that wrapper collapses to
         0px wide and clips the wordmark to nothing. Neutralise it for this heading only. */
      '.template-index .hero__title{width:100%!important}' +
      '.template-index .hero__title .animation-cropper,' +
      '.template-index .hero__title .animation-contents{' +
        'display:block!important;width:100%!important;overflow:visible!important;transform:none!important;' +
      '}' +

      /* ---- spacing: wordmark -> AVAILABLE NOW -> button ---- */
      '.template-index .hero__subtitle{margin:7px 0 0!important}' +
      '.template-index .hero__title{margin-bottom:0!important}' +
      '.template-index .hero__link{margin-top:10px!important;text-align:center!important;display:flex!important;justify-content:center!important;width:100%}' +
      '.template-index .hero__text-content{align-items:center!important}' +

      /* Blend the hero into the black grid below. The photo ends on a hard horizontal line
         against #000; this ramps the last slice of the slide to that same black so the two
         read as one surface. z-index 2 keeps it under the hero text, which sits at 4. */
      '.template-index .slideshow__slide{position:relative}' +
      '.template-index .slideshow__slide::after{' +
        'content:"";position:absolute;left:0;right:0;bottom:-1px;height:26%;' +
        'background:linear-gradient(to bottom,rgba(0,0,0,0) 0%,rgba(0,0,0,.35) 42%,rgba(0,0,0,.82) 76%,#000 100%);' +
        'pointer-events:none;z-index:2;' +
      '}' +

      /* ---- SHOP NOW: red outline, red text, see-through middle ---- */
      '.template-index .hero__link .btn{' +
        'background:transparent!important;background-color:transparent!important;' +
        'border:2px solid ' + RED + '!important;color:' + RED + '!important;' +
        'box-shadow:none!important;transition:background-color .2s ease,color .2s ease;' +
      '}' +
      '.template-index .hero__link .btn:hover,.template-index .hero__link .btn:focus-visible{' +
        'background-color:' + RED + '!important;color:#fff!important;' +
      '}';
    document.head.appendChild(css);
  }

  /* Header mark -> the red file. Swapping the src (rather than filtering the white one)
     keeps the colour exact and survives theme filter changes.

     The theme's white-out filter and icon colour both land with enough weight that a
     stylesheet rule loses to them, so these are set INLINE with priority — inline
     !important is the one thing nothing else in the cascade can outrank. */
  function redHeader(){
    var url = assetUrl(LOGO_FILE);
    var imgs = document.querySelectorAll('.site-header__logo img, .site-header .site-header__logo-image, header .image-element, .site-header img');
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.classList.contains('re-logo-red')) continue;
      im.classList.add('re-logo-red');
      im.style.setProperty('filter', 'none', 'important');
      if (url) {
        im.removeAttribute('srcset');
        im.src = url;
        /* The logo lives in a <picture>; its <source srcset> wins over img.src, so the
           original art would keep loading. Point the sources at the red file too. */
        var pic = im.parentElement;
        if (pic && pic.tagName === 'PICTURE') {
          var srcs = pic.querySelectorAll('source');
          for (var s = 0; s < srcs.length; s++) { srcs[s].setAttribute('srcset', url); }
        }
      }
    }

    /* hamburger / search / cart.

       These are LINE icons — stroked paths with fill:none. But the theme styles them with
       `.icon { fill: currentcolor }`, so simply recolouring `color` also floods the fill and
       they render as solid blobs. So: read each element's fill FIRST, then recolour, then
       pin the original fill back inline. Fill is preserved exactly whatever it was, which
       also keeps genuinely solid icons solid. */
    var icons = document.querySelectorAll('.site-nav__link--icon, .js-drawer-open-nav, .js-search-header, .js-drawer-open-cart');
    for (var k = 0; k < icons.length; k++) {
      icons[k].style.setProperty('color', RED, 'important');
      var svg = icons[k].querySelector('svg');
      if (!svg) continue;
      /* Line icons per the theme's own rule set (fill:none + stroke:currentcolor). Stated
         explicitly rather than sniffed at runtime: the stylesheet that sets fill:none can
         still be pending when this runs, so reading computed fill here is a race. */
      var isLine = /icon-(hamburger|search|bag|bag-minimal|cart|user|close)/.test(svg.getAttribute('class') || '');
      var parts = svg.querySelectorAll('path, circle, ellipse, line, polygon, polyline, rect');
      svg.style.setProperty('color', RED, 'important');
      if (isLine) { svg.style.setProperty('fill', 'none', 'important'); }
      for (var m = 0; m < parts.length; m++) {
        parts[m].style.setProperty('color', RED, 'important');
        parts[m].style.setProperty('stroke', RED, 'important');
        parts[m].style.setProperty('fill', isLine ? 'none' : RED, 'important');
      }
    }
  }

  /* Swap the hero heading text for the wordmark, keeping the real text as alt so the
     heading still reads as a heading to screen readers and search. */
  function swapWordmark(){
    var url = assetUrl(WORDMARK_FILE);
    if (!url) return;
    var slide = document.querySelector('.slideshow__slide');
    var title = (slide && slide.querySelector('.hero__title')) || document.querySelector('.hero__title');
    if (!title || title.querySelector('.re-wordmark')) return;
    var label = (title.textContent || 'Resident Evil Collection').replace(/\s+/g, ' ').trim();
    var host = title.querySelector('.animation-contents') || title;
    var img = document.createElement('img');
    img.className = 're-wordmark';
    img.src = url;
    img.alt = label;
    img.width = 1649;
    img.height = 352;
    host.innerHTML = '';
    host.appendChild(img);
  }

  function init(){
    injectCss();
    redHeader();

    /* everything below is homepage-only */
    if (document.body && document.body.className.indexOf('template-index') === -1) return;

    swapWordmark();

    /* Match the hero subtitle by position (first subtitle in the first slide) rather than by
       its text, so editing the subheading setting can never break this. */
    var slide = document.querySelector('.slideshow__slide');
    var sub = (slide && slide.querySelector('.hero__subtitle')) || document.querySelector('.hero__subtitle');
    if (!sub) return;
    var contents = sub.querySelector('.animation-contents') || sub;

    contents.innerHTML =
      '<div id="re-home-live" style="line-height:1;text-align:center">'
      + '<span style="display:block;font-size:11px;font-weight:800;letter-spacing:.18em;color:' + RED + '">' + LIVE_TITLE + '</span>'
      + '</div>';
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
